var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteStarIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22218 2.133L8.22118 2.136L6.50018 5.788L2.67518 6.37H2.67318C2.30815 6.42762 1.9666 6.58644 1.68731 6.82844C1.40801 7.07043 1.20218 7.38589 1.09318 7.739C0.983636 8.0877 0.970414 8.45953 1.05491 8.81512C1.13941 9.17072 1.31849 9.49685 1.57318 9.759L4.37518 12.619L3.71218 16.671V16.673C3.59218 17.406 3.88518 18.163 4.49518 18.615C4.79421 18.8368 5.15045 18.9684 5.52185 18.9942C5.89325 19.0201 6.26429 18.9392 6.59118 18.761L6.59618 18.759L10.0002 16.884L13.4052 18.759L13.4092 18.761C13.7369 18.9406 14.1095 19.0219 14.4823 18.9953C14.855 18.9687 15.2123 18.8353 15.5112 18.611C16.1132 18.16 16.4092 17.411 16.2902 16.673V16.671L15.6232 12.618L18.4252 9.758C18.6813 9.4955 18.861 9.16823 18.9452 8.81131C19.0295 8.45439 19.0149 8.08128 18.9032 7.732C18.7927 7.38088 18.5865 7.06753 18.3077 6.82712C18.029 6.5867 17.6887 6.42875 17.3252 6.371H17.3222L13.4952 5.788L11.7752 2.139V2.137C11.6177 1.79814 11.3669 1.51119 11.0522 1.30981C10.7375 1.10843 10.3718 1.00096 9.99818 1C9.22318 1 8.54518 1.456 8.22218 2.133Z",
    fill: "#0E0D18",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteStarIconWhite);
export default __webpack_public_path__ + "static/media/favorite-star-icon_white.cb9e8f4cc51f0ad40a3075ce70db18b5.svg";
export { ForwardRef as ReactComponent };